import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { FormFieldBlueprint, createFormField } from '@backstage/plugin-scaffolder-react/alpha';
import { SecretStagingField } from './SecretStagingField';
import { ForgeCertificationStatusField } from './ForgeCertificationStatusField';

const secretStagingFieldExtension = FormFieldBlueprint.make({
  name: 'SecretStaging',
  params: {
    field: async () =>
      createFormField({
        name: 'SecretStaging',
        component: SecretStagingField,
      }),
  },
});

const forgeCertificationStatusFieldExtension = FormFieldBlueprint.make({
  name: 'ForgeCertificationStatus',
  params: {
    field: async () =>
      createFormField({
        name: 'ForgeCertificationStatus',
        component: ForgeCertificationStatusField,
      }),
  },
});

export const scaffolderFieldsModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [secretStagingFieldExtension, forgeCertificationStatusFieldExtension],
});
